import React from 'react'; // N'oublie pas d'importer React
import './App.css';
import './css/navbar.css';
import './css/navbarchap.css';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Sommaire } from './components/Sommaire';
import 'bootstrap/dist/css/bootstrap.min.css';
import { pdfjs } from 'react-pdf';
import { Helmet } from 'react-helmet'; // Importer React Helmet

/*
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
*/
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.mjs`;

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>L’histoire d’André Bach (1888-1945) – Un résistant français pendant deux guerres mondiales</title>
        <meta
          name="description"
          content="Découvrez l'histoire inspirante d'André Bach, soldat de la Première Guerre mondiale devenu résistant pendant la Seconde. Une vie marquée par deux guerres mondiales et la Résistance française."
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="L’histoire d’André Bach (1888-1945)" />
        <meta property="og:description" content="Découvrez l'histoire d'André Bach, un résistant pendant deux guerres mondiales." />
        <meta property="og:image" content="%PUBLIC_URL%/andre-bach-home.png" />
        <meta property="og:url" content="https://andrebachbiographie1888-1945.netlify.app" />
      </Helmet>
      <NavBar />
      <Banner />
      <Sommaire />
    </div>
  );
}

export default App;
